/**
 * 取引先アコーディオンアイテム
 */

import { Accordion, Group, Avatar, Text, Badge, Box } from "@mantine/core";
import { CheckCircle2, Settings, Mail, FileStack } from "lucide-react";
import { Partner, checkPartnerStatus } from "../../services/partnerService";
import { PartnerSettingsTabs } from "../PartnerSettingsTabs";

interface PartnerAccordionItemProps {
  partner: Partner;
  customerId: string;
  onUpdate: () => Promise<void>;
}

/**
 * 取引先アコーディオンアイテム
 */
export function PartnerAccordionItem({
  partner,
  customerId,
  onUpdate,
}: PartnerAccordionItemProps) {
  const { isCsvConfigured, isEmailConfigured, isAllConfigured, slipTypeCount } =
    checkPartnerStatus(partner);

  return (
    <Accordion.Item value={partner.id}>
      <Accordion.Control>
        <Group justify="space-between" pr="md" wrap="nowrap">
          {/* 左側: アバターと取引先名 */}
          <Group gap="sm">
            <Avatar
              color={isAllConfigured ? "blue" : "gray"}
              radius="xl"
              size="md"
              variant={isAllConfigured ? "filled" : "light"}
            >
              {partner.officialName.substring(0, 1)}
            </Avatar>
            <Text
              fw={700}
              size="lg"
              className="item-title"
              style={{ transition: "color 0.2s ease" }}
            >
              {partner.officialName}
            </Text>
          </Group>

          {/* 右側: ヘルスチェック */}
          <Group gap="xs">
            {isAllConfigured ? (
              <Badge
                variant="filled"
                color="green"
                size="md"
                leftSection={<CheckCircle2 size={14} />}
              >
                設定完了
              </Badge>
            ) : (
              <>
                {/* CSVステータス */}
                {isCsvConfigured ? (
                  <Badge
                    variant="light"
                    color="teal"
                    size="md"
                    leftSection={<CheckCircle2 size={14} />}
                  >
                    CSV設定済
                  </Badge>
                ) : (
                  <Badge
                    variant="outline"
                    color="red"
                    size="md"
                    leftSection={<Settings size={14} />}
                  >
                    CSV未設定
                  </Badge>
                )}

                {/* メールステータス */}
                {isEmailConfigured ? (
                  <Badge
                    variant="light"
                    color="teal"
                    size="md"
                    leftSection={<CheckCircle2 size={14} />}
                  >
                    メール設定済
                  </Badge>
                ) : (
                  <Badge
                    variant="outline"
                    color="red"
                    size="md"
                    leftSection={<Mail size={14} />}
                  >
                    メール未設定
                  </Badge>
                )}
              </>
            )}
            {/* 伝票種別数バッジ */}
            {slipTypeCount > 0 && (
              <Badge
                variant="light"
                color="violet"
                size="md"
                leftSection={<FileStack size={14} />}
              >
                種別設定 {slipTypeCount}件
              </Badge>
            )}
          </Group>
        </Group>
      </Accordion.Control>
      <Accordion.Panel>
        <Box
          style={{
            borderTop: "1px solid var(--mantine-color-default-border)",
            paddingTop: "20px",
            marginTop: "4px",
          }}
        >
          <PartnerSettingsTabs
            customerId={customerId}
            partner={partner}
            onUpdate={onUpdate}
          />
        </Box>
      </Accordion.Panel>
    </Accordion.Item>
  );
}
